import axiosInstance from "./AxiosInstance";
import config from "../config";

export const getNotificationsPerProfile = (page, size, seen) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.notificationsPerProfile,
        method: 'get',
        headers: {
            "Authorization": `Bearer ${token}`
        },
        params: {
            'page': page,
            'size': size,
            'seen': seen
        }
    });
};

export const updateNotificationStatus = (id) => {

    const token = JSON.parse(sessionStorage.getItem('userDetails'))?.result?.token;

    return axiosInstance({
        url: config.routes.updateNotificationSeen(id),
        method: 'put',
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });
};